interface AuthErrorProps {
  message: string | null;
}

export function AuthError({ message }: AuthErrorProps): JSX.Element | null {
  if (!message) return null;
  return (
    <div
      role="alert"
      className="mb-4 rounded-md border-2 border-blood-bright/40 bg-blood-bright/10 px-3 py-2.5 text-sm text-blood shadow-sm"
    >
      {message}
    </div>
  );
}
